import { useMediaQuery } from '@vueuse/core'
import { computed } from 'vue'

export const isLtSm = useMediaQuery('(max-width: 575px)')
export const isSm = computed(() => !isLtSm.value)
export const isLtMd = useMediaQuery('(max-width: 767px)')
export const isMd = computed(() => !isLtMd.value)
export const isLtLg = useMediaQuery('(max-width: 1023px)')
export const isLg = computed(() => !isLtLg.value)
